import React from "react";
import PropTypes from "prop-types";
import { Button, Spinner } from "react-bootstrap";

import FAIcon from "../icons/faIcon";
import StringUtils from "../../inumet_js_lib/utils/stringUtils";
import StylesUtils from "../../res/styles/stylesUtils";

const DEFAULT_BUTTON_TYPE = "info";

function ImgButton(props) {
    let buttonType = StringUtils.notNullNotEmptyNoStrNull(props.buttonType)
        ? props.buttonType
        : DEFAULT_BUTTON_TYPE;
    let outlined = props.outlined ? "outline-" : "";
    let spinnerLoading = null;
    if (props.loading) {
        spinnerLoading = (
            <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
            />
        );
    }
    let classNameDiv = StylesUtils.getMarginClasses(
        props.mt,
        props.mr,
        props.mb,
        props.ml
    );
    let itemsButton = [];
    let className = "";
    let text = "";
    if (props.text) {
        text = props.text;
        className = props.iconAtEnd ? "mr-2" : "ml-2";
    }
    if (!props.iconAtEnd) {
        if (!props.loading) {
            itemsButton.push(
                <FAIcon
                    fas
                    iconId={props.iconId}
                    textOnHover={props.textOnHover}
                />
            );
            itemsButton.push(<span className={className}>{text}</span>);
        } else {
            itemsButton.push(spinnerLoading);
            itemsButton.push(
                <span className={{ className }}>
                    {props.loadingText ? props.loadingText : ""}
                </span>
            );
        }
    } else {
        if (!props.loading) {
            itemsButton.push(<span className={className}>{text}</span>);
            itemsButton.push(
                <FAIcon
                    fas
                    iconId={props.iconId}
                    textOnHover={props.textOnHover}
                />
            );
        } else {
            itemsButton.push(
                <span className={className}>
                    {props.loadingText ? props.loadingText : ""}
                </span>
            );
            itemsButton.push(spinnerLoading);
        }
    }
    return (
        <Button
            className={classNameDiv}
            variant={outlined + buttonType}
            onClick={props.onClick}
            disabled={props.isDisabled}
        >
            {itemsButton}
        </Button>
    );
}

ImgButton.propTypes = {
    fas: PropTypes.bool,
    iconId: PropTypes.string,
    buttonType: PropTypes.string,
    textOnHover: PropTypes.string,
    onClick: PropTypes.func,
    text: PropTypes.string,
    outlined: PropTypes.bool,
    isDisabled: PropTypes.bool,
    loading: PropTypes.bool,
    loadingText: PropTypes.string,
    mr: PropTypes.number,
    ml: PropTypes.number,
    mt: PropTypes.number,
    mb: PropTypes.number,
    iconAtEnd: PropTypes.bool,
    /*size: PropTypes.number,
    verticalCenter: PropTypes.bool,

    iconStyle: PropTypes.object,*/
};

export { ImgButton as default };
